<template>
  <div class="app-header">
    <v-navigation-drawer v-model="drawer" app v-if="!isPublic">
      <v-list style="box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4); padding: 4px">
        <v-list-item>
          <v-list-item-avatar>
            <v-icon size="50">fa-user-circle</v-icon>
          </v-list-item-avatar>
          <span class="sub-desc" v-if="currentUser">{{ currentUser.nomeServidor }}</span>
        </v-list-item>
      </v-list>

      <Menu></Menu>
    </v-navigation-drawer>

    <v-app-bar app class="header-wrapper" flat dark height="94">
      <div class="header-content">
        <div class="header-left-wrapper">
          <v-app-bar-nav-icon @click="drawer = !drawer" color="white" v-if="!isPublic"></v-app-bar-nav-icon>
          <div class="header-left" @click="$router.push('/')">
            <img
              class="header-logo"
              src="@/assets/brasao-sem-texto.png"
              alt="Brasão TCE-MA"
            />
            <span class="header-title">
              Tribunal de Contas<br />do Estado do Maranhão
            </span>
          </div>
        </div>
        <span class="header-portal-title">Publicação</span>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import Menu from './Menu';
export default {
  components: { Menu },
  props: {
    isPublic: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return { drawer: true }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth && this.$store.state.auth.user ? this.$store.state.auth.user : null;
    }
  },
  mounted() {
    //console.log(this.$router)

    if (!this.isPublic && !this.currentUser) {
      this.$router.push('/login');
    }
  },
}
</script>

<style scoped>

/* Vuetify specific overrides to make the header fill the v-app-bar */
::v-deep .v-toolbar__content {
  padding: 0 !important;
  width: 100%;
}

.header-wrapper {
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: linear-gradient(135deg, #021f4a 0%, #054a9b 35%, #0a6ecf 55%, #054a9b 75%, #021f4a 100%) !important;
  background-size: 300% 300% !important;
  animation: gradientShift 12s ease infinite !important;
}

@keyframes gradientShift {
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 2rem;
  box-sizing: border-box;
}

.header-left-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 640px) {
  .header-content {
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 10px 1rem;
  }

  .header-left-wrapper {
    width: 100%;
    justify-content: flex-start;
  }

  .header-left {
    padding: 4px 8px;
    justify-content: center;
  }

  .header-logo {
    height: 46px !important;
  }

  .header-title {
    font-size: 0.85rem !important;
    text-align: left;
  }

  .header-portal-title {
    font-size: 1rem !important;
    padding-bottom: 6px;
    text-align: center;
  }
}

.header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.header-left:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.header-portal-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 0.03em;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.35);
}

.header-logo {
  height: 70px;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.4));
}

.header-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  line-height: 1.35;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);
  letter-spacing: 0.01em;
}
</style>